<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/controle-des-personnes-et-dacces.png'" [alt]="'controle-des-personnes-et-dacces'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Contrôle des <br>personnes et d'accès</h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>Surveillance et contrôle des personnes dans<br> le cadre du maintien de...</h2>
                <p>Centres commerciaux, complexes immobiliers, les administrations, les établissements financiers, bureaux, sites industriels, entrepôts, parkings, chantiers, centres aquatiques, foires commerciales, parcs d’attractions, VIP, … </p>
                <p class="mt-5 mb-2">Pour vos :</p>
                <ul class="mb-2">
                    <li>soirées, discothèques</li>
                    <li>concerts,</li>
                    <li>parcs d’attraction,</li>
                    <li>foires commerciales,</li>
                    <li>fancy-fair,</li>
                    <li>centres aquatiques,</li>
                    <li>complexes commerciaux,</li>
                    <li>évènements socioculturels et sportifs, complexes cinématographiques,…</li>
                </ul>
                <p class="mb-4">
                    Tous nos agents sont régulièrement mis en situation au sein de notre société afin de faire face à tous types de situation et cela dans les règles de l’art dictées ici par le SPFI.<br> Pour un maximum de réussite dans votre domaine
                    d’activité, appuyez-vous sur le professionnalisme d’un partenaire capable d’entretenir avec vous une relation durable basée sur le respect, l’innovation et la performance.PS : Pour vos événements et le travail en discothèque, une analyse
                    encore plus minutieuse sera élaborée. Dans ces deux domaines bien particuliers du gardiennage, un maximum de situations devra être étudié, sous différents angles ainsi que les différentes solutions possibles et réelles applicables
                    sur le terrain. Bref, une analyse du risque réel pour dégager les moyens efficaces à mettre en oeuvre avec des possibilités de contre-mesures, les moyens de fuite et de transport.
                </p>
                <p class="mb-4">Vous organisez une soirée ou votre établissement nécessite un droit d’entrée et vous souhaitez un contrôle efficace ?</p>
                <p class="mb-4">Farco Security vous propose un encadrement professionnel et spécifique pour ce type d’évènement en fonction de la situation géographique et de la diversité des clients. Notre savoir faire permettra à vos clients de passer une soirée en
                    toute tranquillité ainsi que la protection de vos biens et intérêts.</p>
                <p class="mb-4">4 mots d’ordre pour une soirée en toute sécurité :</p>
                <ul class="mb-2">
                    <li>Contrôle d’accès</li>
                    <li>Physionomiste </li>
                    <li>Palpation de sécurité</li>
                    <li>Prévention</li>
                </ul>
                <p>Certaines personnes n’accepteront pas le contrôle d’accès pourtant nécessaires à la sécurité de votre événement ou de votre établissement. Vous devez pouvoir faire confiance à votre service de sécurité qui saura gérer les problèmes en
                    jouant les médiateurs avec diplomatie. Nos agents ont une présentation impeccable, ils assurent aussi bien des services de jour comme de nuit.</p>
            </div>
        </div>
    </div>
</section>